/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".mainCard[_ngcontent-%COMP%]{border:1px solid #ddd;margin:0 auto;border-radius:25px;padding:7px 0;width:100%;border-bottom-left-radius:0;border-bottom-right-radius:0}.mainCardHeader[_ngcontent-%COMP%]{padding:10px 15px}.marginZero[_ngcontent-%COMP%]{margin:0}.mobView[_ngcontent-%COMP%]{display:none}.webView[_ngcontent-%COMP%]{display:block}@media only screen and (max-width:1000px){.mobView[_ngcontent-%COMP%]{display:block}.webView[_ngcontent-%COMP%]{display:none!important}}"];
export { styles as styles };

